import React, { useEffect, useRef, useState } from 'react';
import { Check, ChevronDown } from './Icons';

const STATUS_LABELS = { beta: 'Beta', deprecated: 'Deprecated', hidden: 'Hidden' };

export default function Dropdown({ value, options, onChange, label, minWidth }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = options.find((o) => o.id === value) || options[0];

  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDoc);
    document.addEventListener('keydown', onKey);
    return () => { document.removeEventListener('mousedown', onDoc); document.removeEventListener('keydown', onKey); };
  }, [open]);

  if (!current) return null;

  return (
    <div className="vt-dropdown" ref={ref}>
      <button
        type="button"
        className="vt-dropdown-btn"
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-label={label}
      >
        {current.label}
        {STATUS_LABELS[current.status] && <span className={`vt-status vt-status--${current.status}`}>{STATUS_LABELS[current.status]}</span>}
        <ChevronDown size={14} />
      </button>
      {open && (
        <div className="vt-dropdown-menu" role="listbox" style={minWidth ? { minWidth } : undefined}>
          {options.map((opt) => (
            <button
              type="button"
              key={opt.id}
              role="option"
              aria-selected={opt.id === value}
              className={`vt-dropdown-option${opt.id === value ? ' is-active' : ''}`}
              onClick={() => { onChange(opt.id); setOpen(false); }}
            >
              <span>{opt.label}</span>
              {STATUS_LABELS[opt.status] && <span className={`vt-status vt-status--${opt.status}`}>{STATUS_LABELS[opt.status]}</span>}
              {opt.id === value && <Check size={14} />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
